

export const data = [
    {
        image: require('../../assets/img/slide-1.jpg'),
        title: 'Naka Mura',
    },
    {
        image: require('../../assets/img/slide-1.jpg'),
        title: 'Alfin Surya',
    },
    {
        image: require('../../assets/img/slide-1.jpg'),
        title: 'Wayan Bandeng',
    },
];

